<mat-option class="mat-searchable-select-option">
  <input matInput class="mat-select-search-input mat-select-search-hidden" />

  <!-- Note: the  mat-datepicker-content mat-tab-header are needed to inherit the material theme colors, pulled from ngx-mat-select-search-->
  <div #innerSelectSearch
    class="mat-select-search-inner mat-typography mat-datepicker-content mat-tab-header">

    <div class="mat-select-search-inner-row">
      <input
        class="mat-select-search-input"
        autocomplete="off"
        type="text"
        [formControl]="searchControl"
        #searchSelectInput
        [placeholder]="'searchable-select.label' | translate"
      />
      <mat-spinner *ngIf="searching" class="mat-select-search-spinner" diameter="16"></mat-spinner>

      <button *ngIf="value && !searching" mat-icon-button aria-label="Clear"
        (click)="_reset(true)" class="mat-select-search-clear">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>
  </div>
</mat-option>

<ng-content></ng-content>
